export default {
  series: 1,
  data: 'Category;Weight\nOne;11\nmore;11\ntime;11\ngonna;8\ncelebrate;7\nstop;6\nwere;5\ndont;5\nthe;5\nso;5\nfree;5\nOh;4\nright;4\ndancing;4\nCelebrate;4\nfeeling;4\nyeah;3\nall;3\nWere;3\nMusics;3\ngot;3\nme;3\nand;3\ndance;3\nyou;2\nknow;2\njust;2\nTonight;2\nYeah;1\nIm;1\nfeelin;1\nCelebration;1\nDont;1\nwait;1\ntoo;1\nlate;1\nWe;1\ncant;1\na;1\ncelebration;1\nYou;1\ndo;1\nit;1\nneed;1',
  seriesMapping: [
    {
      name: 0,
      weight: 1
    }
  ]
};
